<template>
  <div class="main">
    <a-form-model id="formLogin" ref="form" class="user-layout-login" :model="form" :rules="rules">
      <a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 24px;" :message="loginErrorInfo" closable
               :after-close="handleCloseLoginError" />

      <!-- 用户名 -->
      <a-form-model-item prop="accountNo">
        <a-input v-model="form.accountNo" size="large" placeholder="账户">
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input>
      </a-form-model-item>

      <!-- 密码 -->
      <a-form-model-item prop="password">
        <a-input-password v-model="form.password" size="large" placeholder="密码">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input-password>
      </a-form-model-item>

      <!-- 邮箱验证码 -->
      <a-row :gutter="16">
        <a-col :span="16">
          <a-form-model-item prop="emailCode">
            <a-input
              v-model="form.emailCode"
              size="large"
              placeholder="邮箱验证码"
              :disabled="!canInputEmailCode"
            >
              <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-button
            size="large"
            :disabled="countdown > 0"
            @click="sendEmailCode"
            style="width: 100%; height: 40px;"
            :loading="sendingEmail"
          >
            {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
          </a-button>
        </a-col>
      </a-row>

      <!-- 滑块验证码组件 -->
      <Verify
        v-if="showCaptcha"
        ref="verify"
        @success="onCaptchaSuccess"
        @error="onCaptchaError"
        mode="pop"
        captchaType="blockPuzzle"
        :imgSize="{ width: '330px', height: '155px' }"
      />

      <!-- 记住密码 -->
      <a-form-model-item prop="rememberMe">
        <a-checkbox :checked="form.rememberMe" @change="rememberMe">记住密码</a-checkbox>
      </a-form-model-item>

      <!-- 登录按钮 -->
      <a-form-item style="margin-top:24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="logining"
          :disabled="!canSubmit || logining"
          @click="handleSubmit"
        >
          登录
        </a-button>
      </a-form-item>

      <div class="user-login-other">
        <!-- 其他链接 -->
      </div>
    </a-form-model>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getCodeImg, sendEmailVerifyCode, checkEmailVerifyCode } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME } from '@/store/mutation-types'
import storage from 'store'

// 引入验证码组件
import Verify from "@/components/verifition/Verify"

export default {
  name: 'Login',
  components: {
    Verify
  },
  data() {
    return {
      // 邮箱验证码相关
      countdown: 0,
      sendingEmail: false,
      canInputEmailCode: false,
      emailToken: '',

      // 滑块验证相关
      showCaptcha: false,
      captchaVerified: false,
      captchaVerification: '',

      // 表单相关
      codeUrl: '',
      isLoginError: false,
      loginErrorInfo: '',
      form: {
        accountNo: '',
        password: '',
        emailCode: '',
        rememberMe: false
      },
      rules: {
        accountNo: [
          { required: true, message: '请输入帐户名', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]{4,20}$/, message: '账号为4-20位字母数字下划线', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度为6-20位', trigger: 'blur' }
        ],
        emailCode: [
          { required: true, message: '请输入邮箱验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '验证码为6位数字', trigger: 'blur' }
        ]
      },
      logining: false,
      captchaEnabled: true,
      redirect: undefined
    }
  },
  computed: {
    canSubmit() {
      return this.captchaVerified
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.getStorage()
  },
  beforeDestroy() {
    // 清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
  methods: {
    // ========== 邮箱验证码相关方法 ==========
     sendEmailCode() {
      // 验证邮箱格式
      if (!this.form.accountNo) {
        this.$message.warning('请输入账号')
        return
      }

      // 显示滑块验证码
      this.showCaptcha = true
      this.$nextTick(() => {
        if (this.$refs.verify) {
          this.$refs.verify.show()
        }
      })
    },

    // 滑块验证成功后发送邮箱验证码
    async sendEmailAfterCaptcha() {
      this.sendingEmail = true
      try {
        const response = await sendEmailVerifyCode({
          account: this.form.accountNo,
          captchaVerification: this.captchaVerification
        })
        if (response.code === '20001') {
          this.$message.success('验证码已发送到您的邮箱')
          this.canInputEmailCode = true
          this.startCountdown()

          // 保存邮箱token用于验证
          this.emailToken = response.data
        } else {
          this.$message.error(response.msg || '发送失败')
        }
      } catch (error) {
        console.error('发送邮箱验证码失败:', error)
        this.$message.error('发送失败，请重试')
      } finally {
        this.sendingEmail = false
      }
    },

    // 验证邮箱验证码
     verifyEmailCode() {
      if (!this.form.emailCode || this.form.emailCode.length !== 6) {
        this.$message.warning('请输入6位验证码')
        return false
      }
      return true
    },

    // 开始倒计时
    startCountdown() {
      this.countdown = 60
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.countdownTimer)
        }
      }, 1000)
    },

    // ========== 滑块验证码相关方法 ==========
    showCaptchaModal() {
      this.showCaptcha = true
      this.$nextTick(() => {
        if (this.$refs.verify) {
          this.$refs.verify.show()
        }
      })
    },

    onCaptchaSuccess(params) {
      console.log('滑块验证成功:', params)
      this.captchaVerified = true
      this.captchaVerification = params.captchaVerification
      this.showCaptcha = false
      this.$message.success('滑块验证通过')

      // 滑块验证成功后自动发送邮箱验证码
      this.sendEmailAfterCaptcha()
    },

    onCaptchaError() {
      this.$message.error('滑块验证失败，请重试')
      this.captchaVerified = false
      this.captchaVerification = ''
    },

    // ========== 原有登录方法 ==========
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.data.img
        }
      })
    },

    getStorage() {
      const accountNo = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (accountNo) {
        this.form = {
          accountNo: accountNo,
          password: password,
          rememberMe: rememberMe
        }
      }
    },

    rememberMe(e) {
      this.form.rememberMe = e.target.checked
    },

    handleSubmit() {
      if (!this.captchaVerified) {
        this.$message.warning('请先完成滑块验证')
        this.showCaptchaModal()
        return
      }
      this.logining = true

      try {
        const valid = this.$refs.form.validate()
        if (!valid) {
          this.logining = false
          return
        }
        // 验证邮箱验证码
        const emailVerified = this.verifyEmailCode()
        if (!emailVerified) {
          this.logining = false
          return
        }

        if (this.form.rememberMe) {
          storage.set(LOGIN_USERNAME, this.form.accountNo)
          storage.set(LOGIN_PASSWORD, this.form.password)
          storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
        } else {
          storage.remove(LOGIN_USERNAME)
          storage.remove(LOGIN_PASSWORD)
          storage.remove(LOGIN_REMEMBERME)
        }

        // 构建登录数据
        const loginData = {
          accountNo: this.form.accountNo,
          password: this.form.password,
          validCodeReqNo: this.emailToken,
          validCode: this.form.emailCode
        }
        this.$store.dispatch('Login', loginData).then((res) => {
          this.$router.push({ path: this.redirect || '/' }).catch(() => { })
        }).catch((err) => {
          console.log('err', err)
          this.loading = false
          setTimeout(() => {
            this.logining = false
          }, 1000)
          if (this.captchaEnabled) {
            this.getCode()
          }
        })

      } catch (error) {
        console.error('登录错误:', error)
        this.$message.error('登录出错，请重试')
        this.resetVerificationStates()
      } finally {
        this.logining = false
      }
    },

    // 重置验证状态
    resetVerificationStates() {
      this.captchaVerified = false
      this.captchaVerification = ''
      this.emailToken = ''
      this.canInputEmailCode = false
      this.form.emailCode = ''
    },

    loginSuccess(res) {
      this.$router.push({ path: this.redirect || '/' })
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
      this.handleCloseLoginError()
    },

    requestFailed(err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.resetVerificationStates()
    },

    handleCloseLoginError() {
      this.isLoginError = false
      this.loginErrorInfo = ''
    }
  }
}
</script>

<style lang="less" scoped>
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .register {
      float: right;
    }
  }
}
</style>